namespace network_ui {
   angular.module("com.vmware.vsphere.client.network").constant("iscsiPortBindingConstants", {
      backingType: {
         STANDARD_VNIC_BACKING_TYPE: "standard",
         DISTRIBUTED_VNIC_BACKING_TYPE: "distributed",
         OPAQUE_VNIC_BACKING_TYPE: "opaque"
      }
   });
}